<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Mail Onay",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      IslemSonucu : {}
    }
  }, 
  created(){
      let Page= {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      }
    this.ActionsFilterGet({
        Service: this.$config.API_ACCOUNT_URL+"Account/confirm-email",
        Page: Page,
        Filter: "&userId="+this.$route.query.userId+
        "&code="+this.$route.query.code
      }).then((res) => {
        this.IslemSonucu = res;
      }); 
  }
}
</script>
<template>
  <div class="account-pages my-5 pt-5">
    <div class="container"> 
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
             
            <h4 class="text-uppercase" v-if="IslemSonucu.Succeeded">Üyeliğiniz Onaylandı.</h4>
            <h4 class="text-uppercase" v-if="!IslemSonucu.Succeeded">Bir Hata Oluştu</h4>
            <div class="mt-5 text-center">
              <router-link tag="a" class="btn btn-primary" to="https://mezunyeni.tarsus.edu.tr/login">Anasayfaya Geri Dön</router-link>
            </div>
          </div>
        </div>
      </div>
 
    </div>
  </div>
</template>

